// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function style(hasSecondaryValue) {
  let offset = hasSecondaryValue ? 25 : 0;
  return {
    textAlign: "right",
    width: `calc(75px + ` + String(offset) + `px)`
  };
}

function AmountTableCell(props) {
  let __decimalPrecision = props.decimalPrecision;
  let __secondaryValueIsExcludingTax = props.secondaryValueIsExcludingTax;
  let secondaryValue = props.secondaryValue;
  let value = props.value;
  let secondaryValueIsExcludingTax = __secondaryValueIsExcludingTax !== undefined ? __secondaryValueIsExcludingTax : false;
  let decimalPrecision = __decimalPrecision !== undefined ? __decimalPrecision : 2;
  let formate = value => I18n.currencyFormat(undefined, "EUR", decimalPrecision, decimalPrecision, value);
  let hasSecondaryValue = Stdlib_Option.isSome(secondaryValue);
  let formattedSecondaryValue = secondaryValue !== undefined ? (
      secondaryValueIsExcludingTax ? formate(secondaryValue) + " " + I18n.t("VAT excl.") : formate(secondaryValue) + " " + I18n.t("VAT incl.")
    ) : undefined;
  return JsxRuntime.jsx("div", {
    children: formattedSecondaryValue !== undefined ? JsxRuntime.jsxs(Stack.make, {
        children: [
          JsxRuntime.jsx(TextStyle.make, {
            children: formate(value),
            maxLines: 1
          }),
          JsxRuntime.jsx(TextStyle.make, {
            children: formattedSecondaryValue,
            variation: "normal",
            size: "xxsmall",
            maxLines: 1
          })
        ],
        space: "xxsmall"
      }) : JsxRuntime.jsx(TextStyle.make, {
        children: formate(value),
        weight: "semibold",
        maxLines: 1
      }),
    style: style(hasSecondaryValue)
  });
}

let make = React.memo(AmountTableCell);

export {
  style,
  make,
}
/* make Not a pure module */
